import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ce797ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "membership-calculator" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calculator-header" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("h2", { class: "calculator-item-heading" }, "Dollars Spent Annually"),
  /*#__PURE__*/_createElementVNode("h2", { class: "calculator-item-heading" }, "Dollars Saved Through PTPN")
], -1))
const _hoisted_3 = { class: "calculator-item-heading" }
const _hoisted_4 = { class: "calculator-item-subheading" }
const _hoisted_5 = { class: "calculator-item-input" }
const _hoisted_6 = { class: "calculator-item-amount-saved" }
const _hoisted_7 = { class: "calculator-total" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "disclaimer" }, " *Discounts are typical discounts from retail/regular pricing. Actual discounts vary for each Preferred Vendor; percentages are for estimate purposes only. "),
  /*#__PURE__*/_createElementVNode("p", { class: "disclaimer" }, " **These amounts represents average costs for these services, which are free with PTPN. Actual costs may vary. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Total Savings", -1))
const _hoisted_10 = { class: "calculator-total-container" }
const _hoisted_11 = { class: "calculator-total-amount" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Per Year", -1))

import { computed, ref } from "vue";
import Cleave from "vue-cleave-component";

interface Item {
    title: string;
    subtitle: string;
    isInput: boolean;
    defaultValue?: number;
    percentSavings?: number;
    value?: number | string;
}

interface Props {
    items: Item[];
}


export default /*#__PURE__*/_defineComponent({
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
    items: Item[];
}


const items = ref([...props.items]);

const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});

const rawValue = (input: number | string) => {
    const val = +(input ? input.toString().replace(/\$|,/g, "") : 0);
    if (isNaN(val)) {
        return 0;
    }
    return val;
};

const savedAmount = (item: Item, format = false) => {
    const itemValue = rawValue(item.value);
    const amount =
        Math.round(itemValue * (item.percentSavings || 1) * 100) / 100;
    if (format) {
        if (!amount) {
            return "--";
        }
        return currencyFormatter.format(amount);
    }
    return amount;
};

const total = computed(() => {
    const total = items.value.reduce((agg, item) => {
        const itemTotal = savedAmount(item) as number;
        return agg + itemTotal;
    }, 0);
    return currencyFormatter.format(total);
});

const inputClicked = (event: any) => {
    try {
        if (event.target.selectionStart === 0) {
            event.target.selectionStart = 1;
        }
    } catch (e) {
        console.error(e);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["calculator-item", {'no-input': !item.isInput}]),
        key: index
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(item.title), 1),
          _createElementVNode("h3", _hoisted_4, _toDisplayString(item.subtitle), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (item.isInput)
            ? (_openBlock(), _createBlock(_unref(Cleave), {
                key: 0,
                modelValue: item.value,
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                options: {
                        prefix: '$',
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand',
                        numeralPositiveOnly: true,
                        noImmediatePrefix: true,
                    },
                raw: false,
                class: "form-control",
                onClick: inputClicked
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(savedAmount(item, true)) + _toDisplayString(!item.isInput ? "**" : ""), 1)
        ])
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h1", _hoisted_11, _toDisplayString(_unref(total)), 1),
        _hoisted_12
      ])
    ])
  ]))
}
}

})